export enum DashboardEditBlock {
  Root = 'DashboardEdit',
}
